import { render, staticRenderFns } from "./PopupUseInvitation.vue?vue&type=template&id=0711da16&scoped=true&"
import script from "./PopupUseInvitation.vue?vue&type=script&lang=ts&"
export * from "./PopupUseInvitation.vue?vue&type=script&lang=ts&"
import style0 from "./PopupUseInvitation.vue?vue&type=style&index=0&id=0711da16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711da16",
  null
  
)

export default component.exports